import Popper from '@di-shared/features/common/Popper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function EnergyUsageTooltip() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      marginLeft={1.5}
      tooltip={
        <div
          role="tooltip"
          tabIndex={0}
        >
          <strong className="tooltip_title">{t('T30491')}</strong>
        </div>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          type="button"
          className="btn_tooltip"
          aria-describedby="tooltipBox01"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
        >
          <span
            className="ic ic_information_20px"
            aria-hidden="true"
          />
          <span className="blind">{t('T10044')}</span>
        </button>
      </div>
    </Popper>
  );
}

export default EnergyUsageTooltip;
